import { Controller } from "stimulus";

export default class extends Controller {
  lost(event) {
    event.preventDefault();
    this.element.classList.add("event-stages--lost");
  }

  cancel(event) {
    event.preventDefault();
    this.element.classList.remove("event-stages--lost");
  }
}
